import React, { useState, useEffect } from 'react';
import './LiveInput.scss';
import ApiService from '../../../services/ApiService';


const LiveInput = ({
  value, endpoint, fieldName, id, onSave, placeholder, separateControls, onEditModeChange, isPassword,
}) => {
  const [inputState, setInputState] = useState({
    value,
    lastSavedValue: value,
    editMode: false,
  });

  useEffect(() => {
    onEditModeChange(inputState.editMode);
  }, [inputState.editMode, onEditModeChange]);


  const handleChange = (ev) => {
    setInputState({ ...inputState, value: ev.target.value });
  };

  const cancel = () => {
    setInputState(prevState => ({
      ...inputState, value: prevState?.lastSavedValue, editMode: false,
    }));
  };

  const save = async () => {
    const requestData= {};
    requestData[fieldName] = inputState.value;
    setInputState({ ...inputState, editMode: false });
    try {
      const callback = (response) => {
        if (response.status === 200) {
          setInputState({
            editMode: false,
            lastSavedValue: inputState.value,
            value: inputState.value,
          });
          onSave(value);
        } else {
          setInputState({
            ...inputState,
            editMode: true,
            value: inputState.lastSavedValue,
          });
        }
      };
      await ApiService.patch(`${endpoint}/${id}${isPassword ? '/password' : ''}`, requestData).then(callback);
    } catch {
      setInputState({
        ...inputState,
        editMode: true,
        value: inputState.lastSavedValue,
      });
    }
  };

  const classes = ['live-input', 'edit-mode', 'd-flex', 'align-items-center'];
  if (separateControls) {
    classes.push('separate-controls');
  }

  if (inputState.editMode) {
    return (
      <span className={classes.join(' ')}>
        <input
          className="form-control"
          placeholder={placeholder}
          value={inputState.value}
          onChange={ev => handleChange(ev)}
          width={200}
        />
        { separateControls ? <br /> : null}
        <br />
        <button type="button" className="align-self-center" onClick={() => save()}>
          <i className="zwicon-checkmark" />
        </button>
        <button type="button" className="align-self-center" onClick={() => cancel()}>
          <i className="zwicon-close" />
        </button>
      </span>
    );
  }
  return (
    <span className={`live-input view-mode ${inputState.editMode ? 'edit-mode' : ''}`} onClick={() => setInputState({ ...inputState, editMode: true })}>
      {
        inputState.value !== null && String(value).length > 0
          ? inputState.value
          : placeholder
      }
    </span>
  );
};

LiveInput.defaultProps = {
  id: 1,
  fieldName: '',
  endpoint: '',
  placeholder: 'N/A',
  separateControls: false,
  onSave: () => { },
  onEditModeChange: () => { },
  isPassword: false,
};

export default LiveInput;
